// test1238
(1238 && 0);
